import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { Reveal } from "@/components/Motion";

export const TierCard = ({ tier, index = 0 }) => (
  <Reveal delay={index * 0.1}>
    <div
      data-testid={`tier-card-${tier.name.toLowerCase()}`}
      className={`group relative flex h-full flex-col overflow-hidden rounded-2xl border bg-ink-700 p-8 transition-transform duration-500 hover:-translate-y-2 ${
        tier.featured ? "border-amber/60" : "border-white/10 hover:border-amber/40"
      }`}
    >
      {tier.featured && (
        <span className="absolute right-5 top-5 rounded-full bg-amber px-3 py-1 text-[10px] font-medium tracking-widest text-black">
          Most Booked
        </span>
      )}
      <span className="text-xs font-semibold uppercase tracking-[0.28em] text-amber">{tier.label}</span>
      <h3 className="mt-4 font-head text-4xl font-medium tracking-tight text-white">{tier.name}</h3>
      <p className="mt-1 text-sm text-white/50">{tier.tagline}</p>

      <div className="mt-6">
        <span className="inline-flex items-center rounded-full bg-amber/15 px-3 py-1.5 text-xs font-semibold uppercase tracking-widest text-amber">
          Project-Based Fee
        </span>
        <p className="mt-3 text-sm leading-relaxed text-white/55">
          Reasonably priced to match the scope of your project — no rigid hourly rate.
        </p>
      </div>

      <p className="mt-5 text-sm leading-relaxed text-white/60">{tier.desc}</p>

      <ul className="mt-6 space-y-3">
        {tier.features.map((f) => (
          <li key={f} className="flex items-start gap-3 text-sm text-white/75">
            <Check className="mt-0.5 h-4 w-4 shrink-0 text-amber" strokeWidth={3} />
            {f}
          </li>
        ))}
      </ul>

      <Link
        to="/contact"
        state={{ tier: tier.id }}
        data-testid={`tier-cta-${tier.name.toLowerCase()}`}
        className={`mt-8 inline-flex items-center justify-center rounded-full px-6 py-3 text-sm font-medium uppercase tracking-[0.2em] transition-transform duration-300 hover:scale-[1.03] ${
          tier.featured ? "bg-amber text-black" : "border border-white/20 text-white hover:border-amber hover:text-amber"
        }`}
      >
        Book {tier.name} Consult
      </Link>
    </div>
  </Reveal>
);
